var map = {
	"./emissionen.png": 70,
	"./emissionen.svg": 20,
	"./flaechenverbrauch-01.png": 71,
	"./flaechenverbrauch-01.svg": 21,
	"./flaechenverbrauch-02.png": 72,
	"./flaechenverbrauch-02.svg": 22,
	"./geburtenschlachtungen.png": 73,
	"./geburtenschlachtungen.svg": 23,
	"./kueheundboeings.png": 74,
	"./kueheundboeings.svg": 24,
	"./laktationszyklus-01.png": 75,
	"./laktationszyklus-01.svg": 25,
	"./laktationszyklus-02.png": 76,
	"./laktationszyklus-02.svg": 26,
	"./main_illu_1.png": 77,
	"./main_illu_1.svg": 78,
	"./main_illu_11.png": 79,
	"./main_illu_11.svg": 80,
	"./main_illu_12.png": 81,
	"./main_illu_12.svg": 82,
	"./main_illu_13.png": 83,
	"./main_illu_13.svg": 84,
	"./main_illu_2.png": 85,
	"./main_illu_2.svg": 86,
	"./main_illu_3.png": 87,
	"./main_illu_3.svg": 88,
	"./main_illu_4.png": 89,
	"./main_illu_4.svg": 90,
	"./main_illu_5.png": 91,
	"./main_illu_5.svg": 92,
	"./main_illu_7.png": 93,
	"./main_illu_7.svg": 94,
	"./main_illu_8.png": 95,
	"./main_illu_8.svg": 96,
	"./main_illu_9.png": 97,
	"./main_illu_9.svg": 98,
	"./melksysteme-01.png": 99,
	"./melksysteme-01.svg": 100,
	"./melksysteme-02.png": 101,
	"./melksysteme-02.svg": 102,
	"./milchpreis-01.png": 103,
	"./milchpreis-01.svg": 27,
	"./milchpreis-02.png": 104,
	"./milchpreis-02.svg": 28,
	"./milchprodukte-01.png": 105,
	"./milchprodukte-01.svg": 29,
	"./milchprodukte-02.png": 106,
	"./milchprodukte-02.svg": 30,
	"./milchproduktion-01.png": 107,
	"./milchproduktion-01.svg": 31,
	"./milchproduktion-02.png": 108,
	"./milchproduktion-02.svg": 32,
	"./rinderprobetrieb-01.png": 109,
	"./rinderprobetrieb-01.svg": 33,
	"./rinderprobetrieb-02.png": 110,
	"./rinderprobetrieb-02.svg": 34,
	"./schlachthof-01.png": 111,
	"./schlachthof-01.svg": 35,
	"./schlachthof-02.png": 112,
	"./schlachthof-02.svg": 36,
	"./subventionen-01.png": 113,
	"./subventionen-01.svg": 114,
	"./subventionen-02.png": 115,
	"./subventionen-02.svg": 16,
	"./timebg.svg": 116,
	"./verendetnachalter-01.png": 117,
	"./verendetnachalter-01.svg": 118,
	"./verendetnachalter-02.png": 119,
	"./verendetnachalter-02.svg": 120,
	"./viehschau-01.png": 121,
	"./viehschau-01.svg": 37,
	"./viehschau-02.png": 122,
	"./viehschau-02.svg": 38,
	"./waytofthecow.svg": 123,
	"./wurst.png": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;